export default __webpack_public_path__ + "static/product-unit-5-passport-d291de5b41a21bd58461e159ceeae2c0.png";